var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal-header"},[_c('div',{staticClass:"header-left"},[_c('sidebar-toggle-button')],1),_c('div',{staticClass:"header-right"},[_c('user-setting',{staticStyle:{"margin-left":"20px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }